import React from 'react';

const NotFound = () => {
    return (
        <div className="text-center">
            <h1>URL Not Found</h1>
            <h3>404</h3>
        </div>
    );
};

export default NotFound;